/**
 * Design token values for use in non-className contexts (e.g. ActivityIndicator color, style props).
 * Source of truth: src/theme/colors.json. CSS variables are generated from it (theme:generate).
 */
import palette from './theme/colors.json'

export { spacing } from './theme/spacing'

export const colors = palette as {
  readonly primary: string
  readonly primary100: string
  readonly primary400: string
  readonly primaryForeground: string
  readonly destructive: string
  readonly success: string
  readonly coreSuccess: string
  readonly coreSecondary: string
  readonly corePink: string
  readonly corePrimary: string
  readonly corePinkFill: string
  readonly corePrimaryFill: string
  readonly ink: string
  readonly inkSecondary: string
  readonly muted: string
  readonly border: string
  readonly fill: string
  readonly fillInput: string
  readonly surface: string
  readonly borderSurface: string
  readonly accent: string
  readonly accentForeground: string
  readonly warning: string
  readonly warningForeground: string
  readonly ctaTint: string
  readonly tipBg: string
  readonly avatarBg: string
  readonly disabled: string
  readonly disabledText: string
  readonly buttonSecondary: string
  readonly secondary700: string
  readonly onboardingSignin: string
  readonly textHeader: string
  readonly textMuted: string
  readonly textBody: string
  readonly background: string
  readonly backgroundPrimary: string
  readonly backgroundSecondary: string
  readonly grayMid: string
  readonly errorBackground: string
}
